// @flow
import * as React from 'react';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

import { CheckboxContainer, Icon, StyledCheckbox } from './styles';

const Checkbox = ({
  checked,
  id,
  onChange,
  treatmentFormName,
  bgColor,
  noBorder,
  smallCheck,
  formDoctor
}: {
  checked: boolean,
  id: string,
  treatmentFormName?: string,
  onChange: Function,
  bgColor?: string,
  noBorder?: boolean,
  formDoctor?: boolean,
  smallCheck?: boolean,
}) => (
  <CheckboxContainer
    checked={checked}
    showid={id}
    onClick={() => onChange(!checked)}
    treatmentFormName={treatmentFormName}
    bgColor={bgColor} // white Background
    noBorder={noBorder}
    smallCheck={smallCheck}
  >
    <StyledCheckbox id={id} smallCheck={smallCheck}>
      <Icon icon={faCheck} formDoctor={formDoctor} smallCheck={smallCheck} />
    </StyledCheckbox>
  </CheckboxContainer>
);

export default Checkbox;
